// extracted by mini-css-extract-plugin
export default {"bodyFooter":"Footer_bodyFooter__qKion","icons":"Footer_icons__p7k6r","copyright":"Footer_copyright__LVjDG"};